import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import BooksPage from './pages/BooksPage';
import StudentsPage from './pages/StudentsPage';
import TestPage from './pages/TestPage';
import QuizPage from './pages/QuizPage';
import ResultsPage from './pages/ResultsPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminPage from './pages/AdminPage';
import ProfilePage from './pages/ProfilePage';
import QuestionManagementPage from './pages/QuestionManagementPage';
import ReviewerPage from './pages/ReviewerPage';
import RankingsPage from './pages/RankingsPage';
import DashboardPage from './pages/DashboardPage';
import CertificatesPage from './pages/CertificatesPage';
import CertificateDetailPage from './pages/CertificateDetailPage';
import { AlertProvider } from './contexts/AlertContext';
import { LanguageProvider } from './contexts/LanguageContext';
import './App.css';

function App() {
  return (
    <AlertProvider>
      <LanguageProvider>
        <Router>
          <div className="App">
            <ScrollToTop />
            <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/admin/questions" element={<QuestionManagementPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/game-progress" element={<CertificatesPage />} />
              <Route path="/certificates" element={<CertificatesPage />} />
              <Route path="/certificates/:certificate_id" element={<CertificateDetailPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/reviewer" element={<ReviewerPage />} />
              <Route path="/books" element={<BooksPage />} />
              <Route path="/students" element={<StudentsPage />} />
              <Route path="/rankings" element={<RankingsPage />} />
              <Route path="/test" element={<TestPage />} />
              <Route path="/quiz/:bookId/:difficulty" element={<QuizPage />} />
              <Route path="/results/:sessionId" element={<ResultsPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
      </LanguageProvider>
    </AlertProvider>
  );
}

export default App; 